module.exports = __webpack_public_path__ + "static/strip1cen-4c6f2dc35ab732a250abd488cc7e123a.jpg";